module.exports = __webpack_public_path__ + "img/6.97cbc437.png";